import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon/Icon';

const ClientGroupSafo = ({
  id,
  clientPlatformConfigs,
  readOnly,
  updateState,
  selectedPlatform,
}) => {
  const platformId = Number(selectedPlatform);
  const currentConfig = platformId
    ? clientPlatformConfigs.find((cfg) => cfg.platform && Number(cfg.platform.id) === platformId)
    : null;
  const checked = Boolean(currentConfig && currentConfig.is_client_group_safo);

  const handleToggle = () => {
    const clientId = Number(id);
    if (!(clientId > 0) || !(platformId > 0)) return;

    const next = !checked;
    const baseEntry = {
      client: { id: clientId },
      platform: { id: platformId },
      is_client_group_safo: next,
    };

    // Match by platform.id rather than reference equality so the toggle stays
    // correct if upstream selectors return new object references between renders.
    const updated = currentConfig
      ? clientPlatformConfigs.map((cfg) =>
          cfg.platform && Number(cfg.platform.id) === platformId ? { ...cfg, ...baseEntry } : cfg
        )
      : [...clientPlatformConfigs, baseEntry];

    updateState('client_platform_configs', updated);
  };

  return (
    <div className="page-profil__block-info">
      <div className="block-info__entete">
        <Icon className="entete__icon" content="\e90a" />
        <span className="entete__label"> Client groupe</span>
      </div>
      <div className="block-info__content total">
        <div className="total__type-block">
          <div className="total__type">
            <div className="content__ligne">
              <label
                htmlFor={`is_client_group_safo_${platformId || 'none'}`}
                className="bold ligne__attribut"
              >
                {' '}
                Client groupe :
              </label>
              <label className="switch">
                <input
                  type="checkbox"
                  id={`is_client_group_safo_${platformId || 'none'}`}
                  name="is_client_group_safo"
                  aria-label="Client groupe SAFO"
                  checked={checked}
                  disabled={readOnly || !selectedPlatform}
                  onChange={handleToggle}
                />
                <span className="slider round" />
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ClientGroupSafo.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  clientPlatformConfigs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      platform: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
      is_client_group_safo: PropTypes.bool,
    })
  ),
  readOnly: PropTypes.bool,
  updateState: PropTypes.func.isRequired,
  selectedPlatform: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

ClientGroupSafo.defaultProps = {
  id: null,
  clientPlatformConfigs: [],
  readOnly: false,
  selectedPlatform: null,
};

export default ClientGroupSafo;
